import { render } from "./Child-List.vue?vue&type=template&id=9edaaafa"
import script from "./Child-List.vue?vue&type=script&lang=js"
export * from "./Child-List.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__